module.exports = __webpack_public_path__ + "static/media/bambang-staff-web-hubton.6738c624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/bambang-staff-web-hubton.png
// module id = 181
// module chunks = 0